import ImageToolbar from './image-toolbar';
import app from '../../public-api';

app.plugins.register({
  name: 'us:image-adjust-ui',

  extends: 'viewport',

  factory (uScope, viewport) {
    const toolbar = new ImageToolbar(uScope, viewport);

    // HACK ALERT - mutating the viewport
    viewport.toolbar = toolbar;
    return toolbar;
  }
});



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/image-toolbar/image-toolbar-loader.js